var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-07-20
 * @brief SEI 설비유형 Management  개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, reloadSpg, userInfoLoginState } from "../../../../recoil/userState";
//utils
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { Trans } from "react-i18next";
import { alertState } from "../../../../recoil/assessmentState";
import { checkSheetState, compState, loadingBoxState, spgState, urlState } from "../../../../recoil/menuState";
import { useTrans } from "../../../../utils/langs/useTrans";
function SpgView(props) {
    // trans, navgate, ref
    const navigate = useNavigate();
    const t = useTrans();
    //recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const [spgs, setSpgs] = useRecoilState(spgState);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const setRecoilUrlInfo = useSetRecoilState(urlState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [reloadSpgs, setReloadSpgs] = useRecoilState(reloadSpg);
    const [alert, setAlert] = useRecoilState(alertState);
    const [comps, setComps] = useRecoilState(compState);
    //props
    const { handleOpenPop, checksheetName, setWorkMode, setSpgType } = props;
    useEffect(() => {
        //삭제
        handleOpenPop("pop-delete", _jsx(DeletePop, {}));
    }, []);
    //
    const [spgInfo, setSpgInfo] = useState(null);
    const [elecinfos, setElecinfos] = useState([]);
    // const [spgDuty, setSpgDuty] = useState([])
    // const [dutyCode, setdutyCode] = useState([])
    //기본유형 spg Tree
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/company/spg/${spgs.companySpgId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: spgs.spgName + reloadSpgs,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSpgInfo(data.body);
                Elecinfo(data.body.companySpgId);
                // Dutie(data.body.companySpgId);
                setReloadSpgs(false);
            }
        }
    }, [data, reload, reloadSpgs]);
    function Elecinfo(companyspgId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/company/spg/${companyspgId}/elecinfos`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setElecinfos(data.body);
                }
                else {
                }
            }
        });
    }
    /*    async function Dutie(companySpgId) {
             let data: any = null;
             data = await HTTPUTIL.PromiseHttp({
                 "httpMethod": "GET",
                 "appPath": `/product/company/spg/${companySpgId}/duties`,
                 appQuery: {},
                 userToken: userInfo.loginInfo.token,
             });
             if (data) {
                 if (data.codeNum == CONST.API_200) {
                     let duty = []
                     if (data.body.spgDuty.length > 0) {
                         data.body.spgDuty.map((list) => (duty.push(list.dutyCodeId)))
                     }
                     setSpgDuty(duty)
                     setdutyCode(data.body.dutyCode)
                 } else {
  
                 }
             }
         } */
    function CheckSheetMove(e) {
        setRecoilUrlInfo(CONST.URL_CHECKSHEETMANAGEMENT);
        navigate(CONST.URL_CHECKSHEETMANAGEMENT);
        setCheckSheet({
            sheetType: checksheetName[1],
            spgName: spgs.spgName,
        });
    }
    //spg 선택
    function SpgEdit(e) {
        setWorkMode("UPDATE");
    }
    // 활성화 버튼 on/off
    function IsonSpg(boolean) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/company/spg/${spgInfo.companySpgId}/isonSpg`,
                appQuery: {
                    isonSpg: boolean,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    setReload(true);
                    setReloadSpgs(true);
                    setRecoilIsLoadingBox(false);
                }
                else {
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // 설비 유형 등록
    function onClickSaved(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: "/product/spg",
                appQuery: {
                    spgName: spgs.spgName,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    if (elecinfos.length > 0) {
                        ElecInfoCeatre(data.body);
                    }
                    else {
                        // if (spgDuty.length > 0) {
                        //     JobCeatre(data.body)
                        // } else {
                        setReload(true);
                        setCheckSheet({
                            sheetType: checksheetName[0],
                            spgName: data.body.spgName,
                        });
                        setSpgType(checksheetName[0]);
                        setSpgs({
                            spgId: data.body.spgId,
                            compSpgId: -1,
                            companySpgId: -1,
                            spgName: data.body.spgName,
                        });
                        setComps({
                            companyId: "",
                            companyName: "",
                            id: -1,
                        });
                        setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: t("라벨.기본설비유형이등록되었습니다") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setReload(false);
                        setRecoilIsLoadingBox(false);
                    }
                    // }
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: data.body.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // elec info 등록
    function ElecInfoCeatre(info) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            var success = [];
            var fail = [];
            for (let i = 0; i < elecinfos.length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: "/product/spg/elecinfo",
                    appQuery: {
                        spgId: info.spgId,
                        name: elecinfos[i].elecInfoName,
                        unit: elecinfos[i].unit,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                    }
                    else {
                        /*     let msg =data.errorList.map((err) => ({ ...err, no: i + 1 })) */
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                if (fail.length <= 0) {
                    // if (spgDuty.length > 0) {
                    //     JobCeatre(info)
                    // } else {
                    setReload(true);
                    setCheckSheet({
                        sheetType: checksheetName[0],
                        spgName: info.spgName,
                    });
                    setSpgType(checksheetName[0]);
                    setSpgs({
                        spgId: info.spgId,
                        compSpgId: -1,
                        companySpgId: -1,
                        spgName: info.spgName,
                    });
                    setComps({
                        companyId: "",
                        companyName: "",
                        id: -1,
                    });
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: t("라벨.기본설비유형이등록되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setWorkMode("READ");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                    // }
                }
                else if (fail.length > 0) {
                    setReload(true);
                    setCheckSheet({
                        sheetType: checksheetName[0],
                        spgName: info.spgName,
                    });
                    setSpgType(checksheetName[0]);
                    setSpgs({
                        spgId: info.spgId,
                        compSpgId: -1,
                        companySpgId: -1,
                        spgName: info.spgName,
                    });
                    setComps({
                        companyId: "",
                        companyName: "",
                        id: -1,
                    });
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, pTag: {
                            p1: `성공 ${success.length}건 입니다.`,
                            p2: `실패 ${fail.length}건 입니다.`,
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setWorkMode("READ");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // 직무고시 등록
    /*   async function JobCeatre(info) {
  
            let data: any = null;
            data = await HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                appPath: `/product/spg/${info.spgId}/duty`,
                appQuery: {
                    dutyCodeIds: spgDuty.map((item) => (item))
                },
                userToken: userInfo.loginInfo.token,
            });
  
            if (data) {
                if (data.codeNum == CONST.API_200) {
  
                    setRecoilIsLoadingBox(false);
                    setReload(true);
                    setCheckSheet({
                        sheetType: checksheetName[0],
                        spgName: info.spgName
                    });
                    setSpgType(checksheetName[0])
                    setSpgs({
                        spgId: info.spgId,
                        compSpgId: -1,
                        companySpgId: -1,
                        spgName: info.spgName,
  
                    });
                    setComps({
                        companyId: "",
                        companyName: "",
                        id: -1
                    })
                    setAlert({
                        ...alert,
                        type: CONST.TYPE_ERROR,
                        divTag: t("라벨.기본설비유형이등록되었습니다"),
                    })
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setWorkMode("READ");
                    setReload(false);
                    setRecoilIsLoadingBox(false);
  
                } else {
                    setAlert({
                        ...alert,
                        type: CONST.TYPE_ERROR,
                        divTag: "오류",
                    })
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setRecoilIsLoadingBox(false);
                }
  
  
  
            }
        } */
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsxs("div", Object.assign({ className: "box__header brd-bottom-0 pb-12" }, { children: [_jsxs("h2", Object.assign({ className: "box__title" }, { children: [spgs.spgName, " ", spgs.compSpgId > 0 ? "(기본)" : ""] })), _jsxs("div", Object.assign({ className: "top-button" }, { children: [spgs.compSpgId <= 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-edit", onClick: (e) => SpgEdit(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC218\uC815" })) }))), spgs.compSpgId <= 0 && (_jsx("button", Object.assign({ type: "button", className: "btn btn-delete js-open", "data-pop": "pop-delete", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })))] }))] })), spgInfo && (_jsx("div", Object.assign({ className: "box__body" }, { children: _jsx("div", Object.assign({ className: "content__info" }, { children: _jsxs("ul", { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit " }, { children: t("라벨.영문명") })), _jsx("p", Object.assign({ className: "txt" }, { children: spgInfo.spgNameEnglish }))] }), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.활성화") })), _jsx("div", Object.assign({ className: "txt" }, { children: spgInfo.isonSpg ? (_jsx("p", Object.assign({ className: "treeon", onClick: (e) => IsonSpg(false) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "on" })) }))) : (_jsx("p", Object.assign({ className: "treeoff", onClick: (e) => IsonSpg(true) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "off" })) }))) }))] }), spgInfo.isActive ? (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.체크시트") })), _jsxs("p", Object.assign({ className: "txt" }, { children: [t("라벨.등록완료"), " "] }))] })) : (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.체크시트") })), _jsxs("div", Object.assign({ className: "txt flex-row" }, { children: [_jsx(Trans, Object.assign({ i18nKey: "설비유형관리.미등록체크시트" }, { children: _jsxs("p", Object.assign({ className: "txt-info mt-0" }, { children: ["* \uB4F1\uB85D\uB41C \uCCB4\uD06C\uC2DC\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4. \uB4F1\uB85D \uBC84\uD2BC\uC744 \uB20C\uB7EC \uCCB4\uD06C\uC2DC\uD2B8\uB97C \uC124\uC815\uD574\uC8FC\uC138\uC694.", _jsx("br", {}), "\uCCB4\uD06C\uC2DC\uD2B8 \uB4F1\uB85D\uD558\uBA74 \uC124\uBE44\uC720\uD615\uC774 \uC790\uB3D9\uC73C\uB85C \uD65C\uC131\uD654 \uB429\uB2C8\uB2E4."] })) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic ml-40", onClick: (e) => CheckSheetMove(e) }, { children: _jsxs("span", { children: [t("라벨.체크시트등록"), " "] }) }))] }))] })), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "Elec Info" })), elecinfos && (_jsx("div", Object.assign({ className: "tbl-list txt " }, { children: elecinfos.length <= 0 ? (_jsxs("p", { children: [t("라벨.등록된ElecInfo없음"), " "] })) : (_jsxs("table", Object.assign({ summary: "No.,Elec Info \uBA85,\uB2E8\uC704 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Elec Info \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "Elec Info \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "25%" } }), _jsx("col", { style: { width: "25%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.ElecInfo명") })), _jsxs("th", Object.assign({ scope: "col" }, { children: [t("라벨.ElecInfo명"), "(", t("라벨.영문명"), ")"] })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.단위") })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uB2E8\uC704/\uC120\uD0DD \uC601\uBB38 \uBA85" }))] }) }), _jsx("tbody", { children: elecinfos.map((item, idx) => (_jsxs("tr", { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: item.elecInfoName }), _jsx("td", { children: item.elecInfoNameEnglish }), item.type < 2 ? (_jsx("td", { children: item.unit })) : (_jsx("td", { children: _jsxs("div", Object.assign({ className: `select unit_${idx.toString()}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: item.unit[0] })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: item.unit.map((list, index) => (_jsx("li", Object.assign({ className: "option" }, { children: list }), "unit_" + index.toString()))) })] })) })), item.type < 2 ? (_jsx("td", { children: item.unitEn })) : (_jsx("td", { children: _jsxs("div", Object.assign({ className: `select unitEn_${idx.toString()}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: item.unitEn[0] })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: item.unitEn.map((list, index) => (_jsx("li", Object.assign({ className: "option" }, { children: list }), "unitEn_" + index.toString()))) })] })) }))] }, "elecinfo_" + idx.toString()))) })] }))) })))] }), _jsx("li", {}), userInfo.loginInfo.role == CONST.USERROLE_ADMIN && spgs.compSpgId <= 0 && (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [t("라벨.기본설비유형"), _jsx("br", {}), t("라벨.설정")] })), _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => onClickSaved(e) }, { children: _jsx("span", { children: t("라벨.기본설비유형등록") }) })), _jsxs("p", Object.assign({ className: "txt-info" }, { children: ["* ", t("라벨.기본설비유형으로등록시모든사용자에게보여집니다"), " "] }))] }))] }))] }) })) })))] })) }));
}
export default SpgView;
function DeletePop(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [spgs, setSpgs] = useRecoilState(spgState);
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const [alert, setAlert] = useRecoilState(alertState);
    const setReload = useSetRecoilState(reLoad);
    function SheetDelete(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (spgs.compSpgId > 0) {
                CUTIL.jsclose_Popup("pop-delete");
                setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_ERROR, divTag: "기본 설비유형은 삭제 불가능합니다." }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                let data = null;
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "DELETE",
                    appPath: `/product/company/spg/${spgs.companySpgId}`,
                    appQuery: {},
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        CUTIL.jsclose_Popup("pop-delete");
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_NONE, divTag: data.body }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        setCheckSheet({
                            sheetType: "고객향 점검",
                            spgName: "",
                        });
                        setSpgs({
                            spgId: -1,
                            companySpgId: -1,
                            compSpgId: -1,
                            spgName: "",
                        });
                        setReload(false);
                    }
                    else {
                        // need error handle
                        setReload(true);
                        setAlert(Object.assign(Object.assign({}, alert), { layerId: "pop-delete", type: CONST.TYPE_INNRE, divTag: data.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_InnerPopup(CONST.POP_ALERT, "pop-delete");
                        setReload(false);
                    }
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("p", { children: [t("라벨.설비유형을삭제하시겠습니까"), " "] }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => SheetDelete(e) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
